import { ComboboxTestIdFactory } from '../interactions';
// Built from the option index, as option ids can be customer data
export const optionIdFactory = (comboboxId, optionIndex) => [
    ComboboxTestIdFactory.getComboboxOptionBase(),
    comboboxId,
    optionIndex,
].join('-');
